import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const GET_CUSTOMER_BOUGHT_PRODUCT_IDS: DocumentNode = gql`
  query GetCustomerBoughtProductIds {
    getCustomerBoughtProducts {
      variantIds
    }
  }
`;
